import { render, staticRenderFns } from "./send-confirm.vue?vue&type=template&id=4534667e&scoped=true"
import script from "./send-confirm.vue?vue&type=script&lang=js"
export * from "./send-confirm.vue?vue&type=script&lang=js"
import style0 from "./send-confirm.vue?vue&type=style&index=0&id=4534667e&prod&lang=scss&scoped=true"
import style1 from "./send-confirm.vue?vue&type=style&index=1&id=4534667e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534667e",
  null
  
)

export default component.exports